import { render, staticRenderFns } from "./SwitchToggleajeno.vue?vue&type=template&id=4d497962"
import script from "./SwitchToggleajeno.vue?vue&type=script&lang=ts"
export * from "./SwitchToggleajeno.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports